var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInstagramIcon = function SvgInstagramIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47,3H25.54a3.3,3.3,0,0,1,3.3,3.28V25.35a3.3,3.3,0,0,1-3.3,3.29H6.47a3.3,3.3,0,0,1-3.28-3.29V6.28A3.29,3.29,0,0,1,6.47,3m15.4,2.84A1.16,1.16,0,0,0,20.71,7V9.75a1.15,1.15,0,0,0,1.16,1.16h2.9a1.16,1.16,0,0,0,1.16-1.16V7a1.17,1.17,0,0,0-1.16-1.16Zm4.06,8H23.67A7.4,7.4,0,0,1,24,16a7.86,7.86,0,0,1-8,7.72,7.84,7.84,0,0,1-8-7.72,7.09,7.09,0,0,1,.34-2.21H6V24.67a1,1,0,0,0,1,1H24.91a1,1,0,0,0,1-1ZM16,10.77a5,5,0,1,0,0,10,5.07,5.07,0,0,0,5.17-5,5.07,5.07,0,0,0-5.17-5",
    fill: "currentColor"
  })));
};

export default SvgInstagramIcon;